<div class="relative flex w-[600px] max-w-[calc(100dvw-2rem)] flex-col justify-center overflow-hidden rounded-xl px-6 py-10">
  <div>
    <h3 class="text-center">
      {{ 'chat.thanksModal.title' | transloco }}
    </h3>

    <div class="mt-2">
      <p class="text-center text-base max-md:text-sm">
        {{ 'chat.thanksModal.content' | transloco }}
      </p>
      <p></p>
    </div>
  </div>
</div>
